(() => {
  const track = document.querySelector('.v2ugc-track');
  if (!track) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  document.querySelectorAll('[data-ugc-step]').forEach(button => {
    button.addEventListener('click', () => track.scrollBy({
      left: Number(button.dataset.ugcStep) * (track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)),
      behavior: reduced.matches ? 'instant' : 'smooth'
    }));
  });
  function sync() {
    document.querySelector('.v2ugc-controls').hidden = track.scrollWidth <= track.clientWidth + 4;
    document.querySelector('[data-ugc-step="-1"]').disabled = track.scrollLeft < 4;
    document.querySelector('[data-ugc-step="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  }
  track.addEventListener('scroll', sync, {passive:true});
  addEventListener('resize', sync);
  sync();
  const closePickers = except => track.querySelectorAll('details[open]').forEach(p => { if (p !== except) p.open = false; });
  document.addEventListener('click', e => { if (!e.target.closest('.v2ugc-shop')) closePickers(); });
  track.querySelectorAll('.v2ugc-shop').forEach(p => {
    p.addEventListener('toggle', () => { if (p.open) closePickers(p); });
    p.addEventListener('keydown', e => { if (e.key === 'Escape') { p.open = false; p.querySelector('summary').focus(); } });
  });
  track.querySelectorAll('.v2ugc-visual').forEach(card => {
    const video = card.querySelector('video');
    if (!video) return;
    const button = card.querySelector('.v2ugc-play');
    const stop = () => { video.pause(); };
    const play = async () => {
      track.querySelectorAll('video').forEach(v => { if (v !== video) v.pause(); });
      video.muted = true;
      if (!video.src) video.src = video.dataset.src;
      try { await video.play(); } catch { stop(); }
    };
    card.addEventListener('mouseenter', () => { if (fine.matches && !reduced.matches) play(); });
    card.addEventListener('mouseleave', stop);
    button.addEventListener('click', () => video.paused ? play() : stop());
    video.addEventListener('playing', () => {
      card.classList.add('is-playing'); button.textContent = 'Ⅱ';
      button.setAttribute('aria-label', 'Pausar vídeo'); button.setAttribute('aria-pressed', 'true');
    });
    video.addEventListener('pause', () => {
      card.classList.remove('is-playing'); button.textContent = '▶';
      button.setAttribute('aria-label', 'Reproducir vídeo'); button.setAttribute('aria-pressed', 'false');
    });
    video.addEventListener('error', () => {
      stop(); button.hidden = true;
      const link = card.closest('.v2ugc-card').querySelector('.v2ugc-instagram');
      if (link) link.textContent = 'Ver vídeo en Instagram ↗';
    });
    new IntersectionObserver(entries => { if (!entries[0].isIntersecting) stop(); }, {threshold:0.35}).observe(card);
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); });
  });
})();
